import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zfb",
  "use": "icon-zfb-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-zfb\"><defs><style type=\"text/css\"></style></defs><path d=\"M600.958 597.62s22.523-32.174 45.045-96.527c24.132-64.353 27.348-99.747 27.348-99.747l-183.403-1.609v-62.742l222.015-1.609v-45.045h-222.015v-101.356h-109.398v99.747h-210.752v45.045l207.534-1.609v67.569h-165.705v35.394h342.674s-3.219 28.959-16.090 64.353c-14.478 35.394-27.348 65.962-27.348 65.962s-160.88-56.308-246.146-56.308c-85.266 0-188.23 35.394-197.884 133.531-9.653 98.137 48.265 152.836 130.311 172.142 80.441 19.305 156.052 0 222.015-32.174 65.962-32.174 130.311-104.571 130.311-104.571l341.065 165.705s20.914-32.174 37.003-62.742c16.090-30.567 28.959-64.353 28.959-64.353l-355.546-119.053zM250.24 760.109c-120.659 0-144.794-59.525-144.794-101.356s25.741-88.485 127.095-94.919c101.356-6.434 239.712 72.396 239.712 72.396s-101.356 123.879-222.015 123.879z\" fill=\"\" p-id=\"7272\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zfb.svg
// module id = T9eF
// module chunks = 60